import React from "react";
import FooterLink from "./FooterLink";

// Can be made Generic, but out of score for DSD-3011
const YourPrivacyChoice: React.FC = () => (
        <div className="yourPrivacyLayout">
            <FooterLink label="Your Privacy Choices" url="" onClick={() => OneTrust.ToggleInfoDisplay()}/>
            <div className="yourPrivacyIcon">
                <input type="image" src="/privacy_choices.png" className="privacyIcon" aria-label="Your Privacy Choices" onClick={() => OneTrust.ToggleInfoDisplay()} />
            </div>
        </div>
    );

export default YourPrivacyChoice;
